// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__4r9uf","consentsList":"PatientConsents_consentsList__2aB3A","consentsListEmpty":"PatientConsents_consentsListEmpty__2Y5ck"};